module.exports = new __parcel__URL__("flora.65986469.png").toString();